import {
  Calculator,
  ClipboardList,
  FileText,
  ReceiptText,
  ScrollText,
  Stamp,
} from "lucide-react";

export const toolCards = [
  {
    id: "invoice-generator",
    title: "UK VAT Invoice Generator",
    eyebrow: "Flagship tool",
    description: "Create a UK-style VAT invoice with live totals and one-click PDF export.",
    path: "/invoices",
    action: "Create invoice",
    Icon: FileText,
  },
  {
    id: "quote-generator",
    title: "Quote / Estimate Generator",
    eyebrow: "Before the work",
    description: "Send a polished quote or estimate using the same fast document flow.",
    path: "/quotes",
    action: "Create quote",
    Icon: ClipboardList,
  },
  {
    id: "vat-calculator",
    title: "UK VAT Calculator",
    eyebrow: "Instant utility",
    description: "Add or remove VAT at 20% and copy the breakdown instantly.",
    path: "/vat-calculator",
    action: "Calculate VAT",
    Icon: Calculator,
  },
  {
    id: "tax-estimator",
    title: "Self-Employed Tax Estimator",
    eyebrow: "Rough planning",
    description: "Estimate income tax and National Insurance from annual freelance profit.",
    path: "/tax-estimator",
    action: "Estimate tax",
    Icon: ScrollText,
  },
  {
    id: "receipt-generator",
    title: "Receipt Generator",
    eyebrow: "After payment",
    description: "Generate a simple receipt for paid work, deposits, and client records.",
    path: "/receipts",
    action: "Create receipt",
    Icon: ReceiptText,
  },
  {
    id: "templates",
    title: "UK Templates",
    eyebrow: "Download pages",
    description: "Free invoice, quote, self-employed invoice, and receipt template pages.",
    path: "/templates",
    action: "Browse templates",
    Icon: Stamp,
  },
];

export const templatePages = [
  {
    slug: "vat-invoice-template",
    title: "Free UK VAT Invoice Template",
    keyword: "free UK VAT invoice template",
    description: "Use this template when you are VAT registered and need VAT shown clearly.",
    cta: "Use live invoice generator",
    toolPath: "/invoices",
    documentType: "VAT INVOICE TEMPLATE",
  },
  {
    slug: "freelance-quote-template-uk",
    title: "Free Freelance Quote Template UK",
    keyword: "freelance quote generator UK",
    description: "Use this before work starts to confirm scope, pricing, and validity dates.",
    cta: "Use live quote generator",
    toolPath: "/quotes",
    documentType: "QUOTE TEMPLATE",
  },
  {
    slug: "self-employed-invoice-template-uk",
    title: "Self-Employed Invoice Template UK",
    keyword: "self-employed invoice template UK",
    description: "A clean invoice template for sole traders and independent UK service providers.",
    cta: "Create self-employed invoice",
    toolPath: "/invoices",
    documentType: "SELF-EMPLOYED INVOICE",
  },
  {
    slug: "receipt-template-uk",
    title: "Receipt Template UK",
    keyword: "receipt generator UK",
    description: "Use this after payment to give clients a concise proof of payment.",
    cta: "Use live receipt generator",
    toolPath: "/receipts",
    documentType: "RECEIPT TEMPLATE",
  },
];